import * as actionTypes from '../actions/Actions';

export const initialState = {
    data: {
        isOpen: false,
        response: null,
        load: false,
    },
};

const changePassReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SHOW_CHANGE_PASS_MODAL:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: true,
                    response: action.response,
                }
            };
        case actionTypes.CLOSE_CHANGE_PASS_MODAL:
            return {
                ...state,
                data: {
                    ...state.data,
                    isOpen: false,
                    response: null,
                }
            };
        case actionTypes.LOAD:
            return {
                ...state,
                data: {
                    ...state.data,
                    load: true
                }
            }
        case actionTypes.UNLOAD:
            return {
                ...state,
                data: {
                    ...state.data,
                    load: false
                }
            }
        default:
            return state;
    }
};

export default changePassReducer;